import { useContext, useState, createContext } from "react";

type KanbanSearchContextType = {
    searchTerm : string  | null;
    setSearchTerm : React.Dispatch<React.SetStateAction<string | null>>;
    selectedOptionAttendant : string[] | null;
    setSelectedOptionAttendant : React.Dispatch<React.SetStateAction<string[] | null>>;
    selectedOptionCreatedAt : string | null;
    setSelectedOptionCreatedAt : React.Dispatch<React.SetStateAction<string | null>>;
    startDate : string | null;
    setStartDate : React.Dispatch<React.SetStateAction<string | null>>;
    endDate : string | null;
    setEndDate : React.Dispatch<React.SetStateAction<string | null>>;
}

const KanbanSearchContext = createContext<KanbanSearchContextType | undefined>(undefined)

export const KanbanSearchProvider = ({children} : {children : React.ReactNode}) => {

    const [searchTerm, setSearchTerm] = useState<string | null>("")
    const [selectedOptionAttendant, setSelectedOptionAttendant] = useState<string[] | null>(null)
    const [selectedOptionCreatedAt, setSelectedOptionCreatedAt] = useState<string | null>("")
    const [startDate, setStartDate] = useState<string | null>("")
    const [endDate, setEndDate] = useState<string | null>("")

    return (
        <KanbanSearchContext.Provider value={{
            searchTerm,
            setSearchTerm,
            selectedOptionAttendant,
            setSelectedOptionAttendant,
            selectedOptionCreatedAt,
            setSelectedOptionCreatedAt,
            startDate,
            setStartDate,
            endDate,
            setEndDate
        }}>
            {children}
        </KanbanSearchContext.Provider>
    )

}

export const useKanbanSearch = () => {
    const context = useContext(KanbanSearchContext)
    if(context === undefined){
        throw new Error("useKanbanSearch must be used within a KanbanSearchProvider")
    }
    return context;
}